export const TEST_IDS = {
  CONTAINER: 'app-banner',
  OPEN_LINK: 'app-banner-open-link',
  CLOSE_BUTTON: 'app-banner-close-button',
} as const;
